import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { OrDropdownOption } from '../../models/or-dropdown';

@Component({
    selector: 'or-dropdown-standard',
    templateUrl: './dropdown-standard.component.html',
    styleUrls: ['./dropdown-standard.component.scss'],
    standalone: false
})
export class DropdownStandardComponent implements OnInit, OnChanges {
  currentDisplay: string = '';

  @Input() values: OrDropdownOption[] = [];
  @Input() value: string;
  @Input() text: string = '';
  @Input() showBtn = true;
  @Input() addClickableClass = false;
  @Input() placeholder = "";
  @Input() container = "or-dropdown-standard"
  @Output() selected = new EventEmitter();

  @ViewChild('dropdown', {static: false}) dropdown;

  
  constructor() { }


  ngOnInit() {
    this.updateCurrentDisplay();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['values'] || changes['value']) {
      this.updateCurrentDisplay();
    }
  }

  updateCurrentDisplay() {
    if (this.values == null || this.values.length == 0 || this.value == null) {
      this.currentDisplay = this.placeholder;
      return;
    }
    const selected = this.values.filter(e => e.value == this.value);
    if (selected.length == 0) {
      this.currentDisplay = this.placeholder;
    } else {
      this.currentDisplay = selected[0].name;
    }
  }

  toggleDropdown(event) {
    this.dropdown.toggle(true);
  }
  // getCurrent() is now replaced by currentDisplay property
  applyValue(event, newValue) {
    this.updateCurrentDisplay();
    this.selected.emit(newValue);
    this.dropdown.toggle(true);
  }

}

